module.exports = __webpack_public_path__ + "static/media/blocked.d9cbdcbc.svg";